
export const common = {
  // Navigation
  'nav.features': 'Features',
  'nav.howItWorks': 'How it works',
  'nav.pricing': 'Pricing',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'About Us',
  'nav.getStarted': 'Get Started',

  // About Us Section
  'aboutUs.badge': 'About Us',
  'aboutUs.title': 'About Us',
  'aboutUs.line1': 'Ideas are cheap.',
  'aboutUs.line2': 'Capital is not. Time even less so.',
  'aboutUs.paragraph1':
    'IdeaOracle.ai was founded because most business ideas don\'t fail due to a lack of courage – but due to a lack of honesty. Too much validation. Too little reality.',
  'aboutUs.belief1a': 'We don\'t believe in hype.',
  'aboutUs.belief1b': 'We believe in market logic.',
  'aboutUs.belief2a': 'We don\'t believe in motivation.',
  'aboutUs.belief2b': 'We believe in demand, competition, and differentiation.',
  'aboutUs.mission1': 'Our job is not to make ideas look good.',
  'aboutUs.mission2': 'Our job is to reveal their viability.',
  'aboutUs.analysis':
    'IdeaOracle.ai analyzes business niches for structural market mechanics, realistic demand, competitive intensity, and feasibility. Not emotional. Not optimistic. But sober.',
  'aboutUs.failure1': 'Most ideas fail.',
  'aboutUs.failure2': 'Not because founders are incapable –',
  'aboutUs.failure3': 'but because nobody was clear enough beforehand.',
  'aboutUs.clarity': 'We exist to deliver that clarity.',
  'aboutUs.value1': 'Uncomfortable.',
  'aboutUs.value2': 'Direct.',
  'aboutUs.value3': 'Consistent.',
  'aboutUs.confirm': 'If an idea has substance, we confirm it.',
  'aboutUs.deny': 'If not, we say so too.',
  'aboutUs.noApplause': 'Without applause.',
  'aboutUs.noSugarcoating': 'Without sugarcoating.',
  'aboutUs.noTheater': 'Without theater.',

  // Hero Section
  'hero.badge': 'Decision AI for Business Niches',
  'hero.title1': 'Ideas are cheap.',
  'hero.title2': 'Bad decisions are not.',
  'hero.subtitle': 'An AI that evaluates your business niche',
  'hero.subtitleLine2': 'before you invest.',
  'hero.cta': 'Check Idea',
  'hero.ctaSecondary': 'How it works',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits per request',
  'hero.stat2Value': '7+',
  'hero.stat2Label': 'Rating levels',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Honest & Private',
  'hero.trialTitle': 'Start your free trial',
  'hero.creditsLabel': 'Credits',
  'hero.trialTagline': 'Try our AI assistant free for 3 days',
  'hero.trialCta': 'Sign up & get 250 credits',
  'hero.trialNoCard': 'No credit card required. No commitment.',
  'admin.dashboard.tabs.plans': 'Plans',

  // Features Section
  'features.title1': 'Powerful Features for',
  'features.title2': 'Modern',
  'features.title3': 'Businesses',
  'features.honestVerdict.title': 'Honest Verdict, Not a Hype Score',
  'features.honestVerdict.description': 'Blunt good/mediocre/weak verdicts backed by real market data and competitor research. No 9/10 ratings designed to flatter every idea.',
  'features.fullJourney.title': 'From Idea Check to Builder Report',
  'features.fullJourney.description': 'Validate in chat, dig into the market analysis, export a 25–75 page Builder Report with personas, financials, go-to-market, and pitch deck.',
  'features.multilingual.title': '21 Languages, Local Market Data',
  'features.multilingual.description': 'From a Swiss SME to a solo founder in São Paulo — the AI answers in your language, sourced from your market.',

  // How It Works
  'howItWorks.title': 'How it works',
  'howItWorks.subtitle': 'Four steps to clarity about your business niche.',
  'howItWorks.step1Title': 'Choose a plan',
  'howItWorks.step1Desc': 'Starter, Pro or Builder – depending on the depth of your review.',
  'howItWorks.step2Title': 'Ask the AI',
  'howItWorks.step2Desc': 'Ask your questions about the niche. Each request costs 30 credits.',
  'howItWorks.step3Title': 'Get honest verdict',
  'howItWorks.step3Desc': 'The AI rates: Good, Average or Bad. No sugarcoating.',
  'howItWorks.step4Title': 'Make a decision',
  'howItWorks.step4Desc': "Now you know if it's worth moving forward.",

  // Pricing
  'pricing.title': 'Pricing',
  'pricing.subtitle': 'Choose the plan that fits your review depth.',
  'pricing.yearlyDiscount': 'Annual subscription:',
  'pricing.yearlyDiscountValue': '-20% discount',
  'pricing.perMonth': 'per month',
  'pricing.selectPlan': 'Select Plan',
  'pricing.mostPopular': 'Most Popular',
  'pricing.footer':
    'All prices in CHF. Credits are only deducted for successful AI responses.',

  'pricing.billedYearly': 'Billed yearly',
  'pricing.savings': 'savings',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3-Days Free Access',
  'pricing.trial.credits': '250 Credits',
  'pricing.trial.free': 'Free',
  'pricing.trial.duration': 'No charge for 3 days',
  'pricing.trial.cta': 'Start Free Trial',
  'pricing.trial.feature1': '250 credits to explore the AI',
  'pricing.trial.feature2': 'Full access for 3 days',
  'pricing.trial.feature3': 'No credit card required',
  'pricing.trial.feature4': 'Cancel anytime',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000 Credits + 25-page Builder Report',
  'pricing.gold.credits': '10,000 Credits',
  'pricing.gold.feature1': '10,000 Credits',
  'pricing.gold.feature2': '25-page Builder Report',
  'pricing.gold.feature3': 'All Starter & Pro features',
  'pricing.gold.feature4': 'Market analysis & summary',
  'pricing.gold.feature5': 'Opportunities, risks, recommendations',
  'pricing.gold.feature6': 'Download PDF',
  'pricing.gold.feature7': 'Support',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000 Credits + 75-page Builder Report',
  'pricing.platinum.credits': '15,000 Credits',
  'pricing.platinum.feature1': '15,000 Credits',
  'pricing.platinum.feature2': '75-page Builder Report',
  'pricing.platinum.feature3': 'All Gold features',
  'pricing.platinum.feature4': 'Builder mode: developer briefings',
  'pricing.platinum.feature5': 'Structured summary',
  'pricing.platinum.feature6': 'Advanced market analysis',
  'pricing.platinum.feature7': 'Support',

  // Chat tier / speed mode
  'chat.tier.fast': 'Fast',
  'chat.tier.standard': 'Standard',
  'chat.tier.thinking': 'Thinking',
  'chat.askPrompt': 'Enter your question...',
  'chat.costsLabel': 'costs',

  // Persistent action tray (above chat input, only when an idea is loaded)
  'chat.actionsHint': 'When you\'re ready to build',
  'chat.tray.builderReport': 'Builder Report · {{credits}} cr',
  'chat.tray.devBriefing': 'Dev Briefing · {{credits}} cr',

  // Developer Briefing (Builder / Platinum only)
  'chat.devBriefing.cta': 'Developer Briefing · {{credits}} credits',
  'chat.devBriefing.locked': 'Developer Briefing — {{plans}} plan required',
  'chat.devBriefing.generating': 'Generating developer briefing…',
  'chat.devBriefing.needIdea': 'Analyze an idea first, then I can generate a developer briefing.',
  'chat.devBriefing.planGate': 'Developer Briefing is a Builder / Platinum feature.',
  'chat.devBriefing.failed': 'Developer briefing failed.',

  // Top-up
  'dashboard.credits.topup.button': 'Top up credits',
  'dashboard.credits.topup.buttonTitle': 'Buy more credits without switching plans',
  'dashboard.credits.topup.title': 'Top up credits',
  'dashboard.credits.topup.subtitle': 'CHF 0.15 per credit — no plan change required',
  'dashboard.credits.topup.quickAmounts': 'Quick pick',
  'dashboard.credits.topup.custom': 'Custom',
  'dashboard.credits.topup.totalLabel': 'Total',
  'dashboard.credits.topup.creditsLabel': 'Credits',
  'dashboard.credits.topup.confirm': 'Buy now',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Access to AI niche chatbot',
  'pricing.starter.credits': '2,500 Credits per month',
  'pricing.starter.feature1': 'Free chat (no forms)',
  'pricing.starter.feature2': 'Market logic & honest rating',
  'pricing.starter.feature3': 'Persistent chat history',
  'pricing.starter.feature4': 'Multiple parallel chat sessions',
  'pricing.starter.feature5': 'Fully multilingual',
  'pricing.starter.feature6': 'Credit-based usage',
  'pricing.starter.feature7': 'Monthly reset',
  'pricing.starter.feature8': 'No developer briefings',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Access to AI niche chatbot',
  'pricing.pro.credits': '5,000 Credits per month',
  'pricing.pro.feature1': 'Free chat (no forms)',
  'pricing.pro.feature2': 'Market logic & honest rating',
  'pricing.pro.feature3': 'Persistent chat history',
  'pricing.pro.feature4': 'Multiple parallel chat sessions',
  'pricing.pro.feature5': 'Fully multilingual',
  'pricing.pro.feature6': 'Credit-based usage',
  'pricing.pro.feature7': 'Monthly reset',
  'pricing.pro.feature8': 'No developer briefings',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.price': '199',
  'pricing.builder.description': 'All features + Builder mode',
  'pricing.builder.credits': 'Unlimited Credits',
  'pricing.builder.feature1': 'Free chat (no forms)',
  'pricing.builder.feature2': 'Market logic & honest rating',
  'pricing.builder.feature3': 'Persistent chat history',
  'pricing.builder.feature4': 'Multiple parallel chat sessions',
  'pricing.builder.feature5': 'Fully multilingual',
  'pricing.builder.feature6': 'Builder mode: Developer briefings',
  'pricing.builder.feature7': 'Structured summary',
  'pricing.builder.feature8': 'Fair-use limit',
  'pricing.builder.limitNote': 'Fair-use limit',
  'pricing.monthlyReset': 'Monthly reset',

  // Modal
  'pricing.modal.selected': 'selected',
  'pricing.modal.comingSoon':
    'Registration and payment processing will be available soon.',
  'pricing.modal.patience':
    'We are working to provide you with a secure and seamless experience. Please be patient.',
  'pricing.modal.understood': 'Understood',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Answered honestly & critically.',
  'faq.q1': 'What does IdeaOracle.ai actually do?',
  'faq.a1': 'IdeaOracle.ai evaluates business ideas and niches for market logic, real demand, competition, differentiation, and feasibility.\nIf substance exists, we show how it can be strategically sharpened.\nIf not, we say so.',
  'faq.q2': 'Do you also generate ideas?',
  'faq.a2': 'Yes.\nBut not blindly.\nWe develop approaches based on market logic – not motivation or trend hype.',
  'faq.q3': 'Do you optimize business models?',
  'faq.a3': 'Yes – if potential exists.\nWe don\'t polish illusions.\nWe make viable concepts more resilient.',
  'faq.q4': 'What sets you apart from other AI tools?',
  'faq.a4': 'Other tools deliver inspiration.\nWe deliver assessment.\nThe focus is on realism, not enthusiasm.',
  'faq.q5': 'Is this a guarantee of success?',
  'faq.a5': 'No.\nWe reduce bad decisions – we don\'t eliminate risk.',
  'faq.q6': 'Who is IdeaOracle.ai for?',
  'faq.a6': 'Founders before launch\nEntrepreneurs before expansion\nSide-builders before time investment\nInvestors before due diligence\n\nIn short: For people who want clarity before capital.',
  'faq.q7': 'What if I\'m just looking for validation?',
  'faq.a7': 'Then IdeaOracle.ai is not the right tool.',
  'faq.q8': 'How honest is the analysis?',
  'faq.a8': 'As honest as data and market mechanics allow.\nNo euphoria. No mercy.',
  'faq.q9': 'Do you replace market research?',
  'faq.a9': 'No.\nWe are a strategic pre-assessment – not a full market study.',
  'faq.q10': 'Why so uncompromising?',
  'faq.a10': 'Because failure is expensive.\nHonesty is not.',

  // Footer
  'footer.description':
    "This platform doesn't help you feel good – it helps you decide right.",
  'footer.product': 'Product',
  'footer.aiAssistant': 'AI Assistant',
  'footer.howItWorks': 'How it works',
  'footer.pricing': 'Pricing',
  'footer.faq': 'FAQ',
  'footer.legal': 'Legal',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Terms',
  'footer.imprint': 'Imprint',
  'footer.support': 'Support',
  'footer.contact': 'Contact',
  'footer.documentation': 'Documentation',
  'footer.copyright': '© 2025 IdeaOracle.ai. All rights reserved.',

  // AI Assistant
  'aiAssistant.title': 'AI Niche Assistant',
  'aiAssistant.subtitle': 'Ask about niches',
  'aiAssistant.welcomeMessage':
    'Hi! Describe your idea or ask me about a niche. I will give you a clear and honest evaluation.',
  'aiAssistant.demoResponse':
    'This is a demo. To get real AI evaluations, please register and choose a plan.',
  'aiAssistant.placeholder': 'Describe your idea...',
  'aiAssistant.suggestionsLabel': 'Try one of these',
  'aiAssistant.fallback':
    "I don't have an answer for that one — but a human will. Drop a note to support@ideaoracle.ai and we'll get back to you fast.",

  // 21-intent FAQ — answered by the Talk-with-us widget without burning
  // AI credits. Keywords are in the component; Q and A live here so they
  // localize per user.
  'aiAssistant.faq.what_is.q': 'What is IdeaOracle.ai?',
  'aiAssistant.faq.what_is.a':
    'IdeaOracle.ai is a decision AI for business ideas. You describe an idea or niche; we evaluate market logic, real demand, competition, and viability — no sugarcoating. Good, average, or bad, we tell you straight.',
  'aiAssistant.faq.how_it_works.q': 'How does it work?',
  'aiAssistant.faq.how_it_works.a':
    "Four steps: 1) pick a plan (or start the free trial), 2) open the AI assistant and describe your idea, 3) get a rating (Good / Average / Bad) plus market, competition, strengths, weaknesses, risks, opportunities and recommendations, 4) iterate or generate a full Builder Report (PDF) if you want to actually build it.",
  'aiAssistant.faq.pricing.q': 'How much does it cost?',
  'aiAssistant.faq.pricing.a':
    'Plans (CHF / month): Trial free · Starter 39.90 · Pro 59.90 · Builder 199 · Gold 199 · Platinum 399. Yearly billing is 20% off on every paid plan. Full breakdown on the Pricing section of the homepage.',
  'aiAssistant.faq.plans.q': 'Which plans are available?',
  'aiAssistant.faq.plans.a':
    '6 plans: Trial (250 credits, 3 days, free), Starter (2,500 credits / 39.90 CHF), Pro (5,000 / 59.90), Builder (10,000 / 199 — adds developer briefings + 25-page Builder Report), Gold (12,500 / 199 — 50-page report), Platinum (15,000 / 399 — 75-page report, premium support).',
  'aiAssistant.faq.trial.q': 'Is there a free trial?',
  'aiAssistant.faq.trial.a':
    "Yes — 3 days free with 250 credits. No credit card required. You can cancel anytime or upgrade directly from your dashboard.",
  'aiAssistant.faq.credits.q': 'What is a credit?',
  'aiAssistant.faq.credits.a':
    'A credit is the unit of AI usage — every analysis, chat message, or report costs credits. Each plan includes a monthly credit bucket that resets each billing period; unused credits do not carry over.',
  'aiAssistant.faq.credits_cost.q': 'How many credits does each analysis cost?',
  'aiAssistant.faq.credits_cost.a':
    'Per chat message: Fast 30 credits, Standard 50, Thinking 100. A full idea analysis runs the same tiers. The Builder Report and Developer Briefing are separate (credit cost configurable per workspace).',
  'aiAssistant.faq.run_out_credits.q': 'What happens when I run out of credits?',
  'aiAssistant.faq.run_out_credits.a':
    "You can either wait for the monthly reset, upgrade your plan, or buy a one-time top-up from the Credits panel in your dashboard — no plan change required.",
  'aiAssistant.faq.topup.q': 'Can I buy more credits without upgrading?',
  'aiAssistant.faq.topup.a':
    'Yes. Open your dashboard → Credits → "Top up credits". Rate is CHF 0.15 per credit, minimum 100 credits (CHF 15), maximum 50,000 (CHF 7,500). Credits land in your balance immediately.',
  'aiAssistant.faq.builder_report.q': 'What is the Builder Report?',
  'aiAssistant.faq.builder_report.a':
    "A strategic deep-dive PDF with detailed personas, financial model, unit economics, go-to-market plan, moat analysis, and pitch deck outline. Page count scales with your plan: Builder 25 · Gold 50 · Platinum 75. Generated in a few minutes from any saved idea.",
  'aiAssistant.faq.dev_briefing.q': 'What is the Developer Briefing?',
  'aiAssistant.faq.dev_briefing.a':
    "A 9-section structured product + engineering spec — the document you hand to a developer or agency to start building. Covers what to build, user flow, screens, backend, database, architecture, MVP plan, and an example folder structure. Available on Builder and Platinum plans.",
  'aiAssistant.faq.privacy.q': 'Is my data private?',
  'aiAssistant.faq.privacy.a':
    "Yes. Your ideas are tied to your account only. We don't sell data, don't train public models on it, and don't share it. Full details in our Privacy Policy.",
  'aiAssistant.faq.languages.q': 'Which languages are supported?',
  'aiAssistant.faq.languages.a':
    '21 languages across the UI and AI responses — including English, German, French, Spanish, Italian, Dutch, Portuguese, Polish, Turkish, Russian, Japanese, Korean, Chinese, Hindi, Arabic, and more. Switch anytime from the language selector.',
  'aiAssistant.faq.cancel.q': 'How do I cancel my subscription?',
  'aiAssistant.faq.cancel.a':
    'Dashboard → Subscription → Cancel. You keep full access until the end of the current billing period. No retention-loop, no phone calls.',
  'aiAssistant.faq.refund.q': 'Is there a free trial?',
  'aiAssistant.faq.refund.a':
    "Yes — sign up and use the trial credits to try the platform for free before committing. We don't offer money-back refunds on paid plans, so we recommend testing with the trial first. For exceptional cases, email support@ideaoracle.ai and we'll review individually.",
  'aiAssistant.faq.support.q': 'How do I contact support?',
  'aiAssistant.faq.support.a':
    'Email us at support@ideaoracle.ai — we answer within one business day. You can also keep chatting here for anything our FAQ bot can handle.',
  'aiAssistant.faq.mobile.q': 'Is there a mobile app?',
  'aiAssistant.faq.mobile.a':
    'Not yet. The web app is fully responsive and works well on phones and tablets. A native mobile app is on the roadmap but no release date yet.',
  'aiAssistant.faq.multiple_ideas.q': 'Can I analyze multiple ideas?',
  'aiAssistant.faq.multiple_ideas.a':
    'Yes — every analysis is saved to your history. Open several parallel chat sessions, switch between past ideas, export any of them as PDF, TXT or JSON, or translate them into another language on demand.',
  'aiAssistant.faq.payment.q': 'What payment methods do you accept?',
  'aiAssistant.faq.payment.a':
    'All major credit cards via Stripe. Invoicing for yearly / enterprise plans on request — contact support@ideaoracle.ai.',
  'aiAssistant.faq.who_for.q': 'Who is IdeaOracle for?',
  'aiAssistant.faq.who_for.a':
    "Founders before they start, operators before they expand, side-builders before they invest time, and investors before they write the check. Anyone who wants clarity before capital.",
  'aiAssistant.faq.honesty.q': 'How honest is the AI?',
  'aiAssistant.faq.honesty.a':
    "Blunt. We don't validate for the sake of validation — if an idea is weak, we say so, with reasons. Good ideas get sharpened; bad ideas get killed fast. The point is to save you time and money, not feelings.",

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.tagline': 'Your AI Assistant',
  'dashboard.header.logout': 'Sign out',
  'dashboard.quickActions.creditsCost': '{{count}} credits',
  'chat.builderOfferMessage': 'Want me to turn this into a full Builder Report — a strategic deep-dive with detailed personas, financial model, go-to-market plan, moat analysis, and pitch deck outline? Page count scales with your plan: Builder 25 pages, Gold 50 pages, Platinum 75 pages. See the button below for current credit cost.',
  'chat.builderOfferTitle': 'Ready to build? Generate the full Builder Report',
  'chat.builderOfferCta': 'Generate Builder Report · 200 credits',
  'chat.builderOfferCtaDynamic': 'Generate Builder Report · {{credits}} credits',
  'chat.builderOfferLocked': 'Builder Report — {{plans}} plan required',
  'chat.builderOfferUpgrade': 'Upgrade to {{plans}} to unlock',
  'chat.builderOfferHint': 'or type "generate builder report" to let the AI start it',
  'dashboard.sidebar.overview': 'Overview',
  'dashboard.sidebar.dashboard': 'Dashboard',
  'dashboard.sidebar.aiAssistant': 'AI Assistant',
  'dashboard.sidebar.newAnalysis': 'AI Assistant',
  'dashboard.sidebar.history': 'History',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.subscription': 'Subscription & Billing',
  'dashboard.sidebar.settings': 'Settings',
  'dashboard.sidebar.plan': 'Plan',

  // Shared dashboard labels
  'dashboard.unlimited': 'Unlimited',
  'dashboard.upgrade': 'Upgrade',
  'dashboard.close': 'Close',
  'dashboard.backToOverview': 'Back to overview',

  // Dashboard Overview (full page)
  'dashboard.overview.title': 'Overview',
  'dashboard.overview.last24Hours': 'Last 24 hours',
  'dashboard.overview.loadError': 'Failed to load overview',
  'dashboard.overview.plan': 'Plan',
  'dashboard.overview.unlimitedCredits': 'Unlimited credits available',
  'dashboard.overview.creditsAvailable': '{{formatted}} credits available',
  'dashboard.overview.creditsUsageThisMonth': 'Credit usage this month',
  'dashboard.overview.creditsAvailablePct': '{{pct}}% available',
  'dashboard.overview.recentActivity': 'Recent activity',
  'dashboard.overview.noActivity': 'No activity yet',
  'dashboard.overview.latestIdeas': 'Latest ideas',
  'dashboard.overview.noIdeas': 'No ideas analyzed yet',
  'dashboard.overview.viewAll': 'View all',
  'dashboard.overview.upgradePlan': 'Upgrade plan',
  'dashboard.overview.buyCredits': 'Buy credits',
  'dashboard.overview.quickAccess': 'Quick access',
  'dashboard.overview.quickAccessItems.startAnalysis': 'Start new analysis',
  'dashboard.overview.quickAccessItems.startAnalysisDesc': 'Start a new AI-powered niche analysis',
  'dashboard.overview.quickAccessItems.myAnalyses': 'My analyses',
  'dashboard.overview.quickAccessItems.myAnalysesDesc': 'View all previous analyses',
  'dashboard.overview.quickAccessItems.buyCredits': 'Buy credits',
  'dashboard.overview.quickAccessItems.buyCreditsDesc': 'More credits for more analyses',
  'dashboard.overview.quickAccessItems.settings': 'Settings',
  'dashboard.overview.quickAccessItems.settingsDesc': 'Customize profile and preferences',
  'dashboard.overview.stats.analysesToday': 'Analyses today',
  'dashboard.overview.stats.analysesTotal': 'Total analyses',
  'dashboard.overview.stats.successRate': 'Success rate',
  'dashboard.overview.stats.topRatings': 'Top ratings',
  'dashboard.overview.activity.nicheAnalysisComplete': 'Niche analysis completed',
  'dashboard.overview.activity.refund': 'Refund',
  'dashboard.overview.activity.payment': 'Payment',
  'dashboard.overview.time.justNow': 'just now',
  'dashboard.overview.time.minutesAgo': '{{count}} min ago',
  'dashboard.overview.time.hoursAgo': '{{count}} h ago',
  'dashboard.overview.time.daysAgo_one': '{{count}} day ago',
  'dashboard.overview.time.daysAgo_other': '{{count}} days ago',
  'dashboard.overview.time.daysAgo': '{{count}} days ago',

  // Chat additions
  'chat.ratingStrong': 'Strong',
  'chat.ratingMixed': 'Mixed',
  'chat.ratingWeak': 'Weak',
  'chat.loadIdeaError': 'Could not load idea',
  'chat.deleteError': 'Delete failed',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.currentBalance': 'Your current balance:',
  'chat.ai': 'AI',
  'chat.you': 'You',

  // Chat — speech recognition
  'chat.speechNotSupported': 'Speech recognition is not supported by your browser.',
  'chat.microphonePermissionDenied': 'Microphone access was denied.',
  'chat.listeningPlaceholder': 'I\'m listening… speak now.',
  'chat.stopListening': 'Stop recording',
  'chat.recording': 'Recording…',

  // Chat — session actions & toasts
  'chat.renameSuccess': 'Name updated (local only)',
  'chat.deleted': 'Chat deleted',

  // Chat — export
  'chat.export': 'Export',
  'chat.exportAll': 'Export',
  'chat.exportSuccess': 'Export successful!',
  'chat.allExportSuccess': 'All chats exported!',
  'chat.noSessionsToExport': 'No chats to export',
  'chat.allChats': 'All chat histories',
  'chat.exportedOn': 'Exported on',
  'chat.totalChats': 'Total chats',
  'chat.chat': 'Chat',
  'chat.createdAt': 'Created',
  'chat.updatedAt': 'Updated',

  // Chat — AI typing & credit banners
  'chat.aiTyping': 'AI is typing…',
  'chat.noCreditsTitle': 'No credits remaining',
  'chat.noCreditsDesc': 'Please upgrade your plan.',
  'chat.lowCreditsTitle': 'Credits are running low',
  'chat.lowCreditsDesc_one': '{{count}} credit remaining.',
  'chat.lowCreditsDesc_other': '{{count}} credits remaining.',
  'chat.lowCreditsDesc': '{{count}} credits remaining.',

  // Chat — sidebar counts
  'chat.messagesCount_one': '{{count}} message',
  'chat.messagesCount_other': '{{count}} messages',
  'chat.messagesCount': '{{count}} messages',

  // Rating (additional)
  'rating.unknown': 'Unknown',

  // Credit Usage
  'dashboard.credits.title': 'Credit usage',
  'dashboard.credits.subtitle': 'Your current consumption',
  'dashboard.credits.loadError': 'Failed to load credits',
  'dashboard.credits.downgradePending': 'Downgrade is awaiting administrator approval.',
  'dashboard.credits.planUpdated': 'Plan updated successfully!',
  'dashboard.credits.planChangeFailed': 'Plan change failed',
  'dashboard.credits.planSuffix': 'Plan',
  'dashboard.credits.downgradeWaiting': 'Downgrade awaiting approval',
  'dashboard.credits.used': 'Used',
  'dashboard.credits.resetOn': 'Reset on {{date}}',
  'dashboard.credits.recentActivity': 'Recent activity',
  'dashboard.credits.noActivity': 'No activity yet',
  'dashboard.credits.currentPackage': 'Your current package',
  'dashboard.credits.chfPerMonth': 'CHF/month',
  'dashboard.credits.creditsPerMonth': '{{formatted}} credits/month',
  'dashboard.credits.perMonth': 'per month',
  'dashboard.credits.upgradePackage': 'Upgrade package',
  'dashboard.credits.changePlan': 'Change plan',
  'dashboard.credits.current': 'Current',
  'dashboard.credits.premium': 'Premium',
  'dashboard.credits.noPlans': 'No plans available.',
  'dashboard.credits.currentPlan': 'Current plan',
  'dashboard.credits.selected': 'Selected',
  'dashboard.credits.selectPlan': 'Select {{plan}}',
  'dashboard.credits.processing': 'Processing...',
  'dashboard.credits.switchPlan': 'Switch plan',
  'dashboard.credits.tx.deduction': 'Credits used',
  'dashboard.credits.tx.reset': 'Monthly reset',
  'dashboard.credits.tx.bonus': 'Bonus credits',
  'dashboard.credits.tx.refund': 'Refund',

  // Idea History
  'dashboard.history.title': 'Idea history',
  'dashboard.history.loadError': 'Failed to load ideas',
  'dashboard.history.analysesCount': '{{count}} analyses',
  'dashboard.history.yourLatest': 'Your latest analyses',
  'dashboard.history.refresh': 'Refresh',
  'dashboard.history.exportAll': 'Export all',
  'dashboard.history.searchPlaceholder': 'Search ideas...',
  'dashboard.history.allRatings': 'All ratings',
  'dashboard.history.emptyTitle': 'No analyses yet',
  'dashboard.history.emptyDesc': 'Start a chat to evaluate your first business idea. Completed analyses will appear here automatically.',
  'dashboard.history.startFirstChat': 'Start your first chat',
  'dashboard.history.noMatchTitle': 'No results',
  'dashboard.history.noMatchDesc': 'No analysis matches your filter. Adjust your search or rating.',
  'dashboard.history.fullAnalysis': 'Full analysis',
  'dashboard.history.translating': 'Translating analysis into your current language…',
  'dashboard.history.download': 'Download',
  'dashboard.history.saveAsJson': 'Save as JSON',
  'dashboard.history.saveAsTxt': 'Save as TXT',
  'dashboard.history.saveAsPdf': 'Save as PDF',
  'dashboard.history.deleteAnalysisTitle': 'Delete analysis?',
  'dashboard.history.actionIrreversible': 'This action cannot be undone.',
  'dashboard.history.deleteSuccess': 'Analysis deleted successfully',
  'dashboard.history.deleteError': 'Delete failed',
  'dashboard.history.jsonSuccess': 'JSON file downloaded successfully',
  'dashboard.history.txtSuccess': 'TXT file downloaded successfully',
  'dashboard.history.pdfSuccess': 'PDF file downloaded successfully',
  'dashboard.history.exportError': 'Export failed',
  'dashboard.history.allExportedAsJson': '{{count}} ideas exported as JSON',
  'dashboard.history.marketAnalysis': 'Market analysis',
  'dashboard.history.swotAnalysis': 'SWOT analysis',
  'dashboard.history.recommendations': 'Recommendations',
  'dashboard.history.actionRecommendations': 'Action recommendations',
  'dashboard.history.export.header': 'IDEA ANALYSIS EXPORT',
  'dashboard.history.export.title': 'Title',
  'dashboard.history.export.rating': 'Rating',
  'dashboard.history.export.date': 'Date',
  'dashboard.history.export.category': 'Category',
  'dashboard.history.export.targetAudience': 'Target audience',
  'dashboard.history.export.metrics': 'Metrics',
  'dashboard.history.export.summary': 'Summary',
  'dashboard.history.export.exportedOn': 'Exported on',
  'dashboard.history.pdf.header': 'Business idea analysis',
  'dashboard.history.metrics.marketSize': 'Market size',
  'dashboard.history.metrics.competition': 'Competition',
  'dashboard.history.metrics.startupCost': 'Startup cost',
  'dashboard.history.metrics.timeToMarket': 'Time to market',
  'dashboard.history.metrics.profitPotential': 'Profit potential',
  'dashboard.history.metrics.scalability': 'Scalability',
  'dashboard.history.swot.strengths': 'Strengths',
  'dashboard.history.swot.weaknesses': 'Weaknesses',
  'dashboard.history.swot.opportunities': 'Opportunities',
  'dashboard.history.swot.threats': 'Threats',

  // Settings
  'dashboard.settings.title': 'Settings',
  'dashboard.settings.subtitle': 'Manage your account and preferences',
  'dashboard.settings.loadError': 'Failed to load settings',
  'dashboard.settings.profileSaved': 'Profile saved successfully',
  'dashboard.settings.preferencesSaved': 'Preferences saved successfully',
  'dashboard.settings.notificationsSaved': 'Notification settings saved',
  'dashboard.settings.saveFailed': 'Save failed',
  'dashboard.settings.saving': 'Saving...',
  'dashboard.settings.saveChanges': 'Save changes',
  'dashboard.settings.deleting': 'Deleting...',
  'dashboard.settings.deleteConfirmKeyword': 'DELETE',
  'dashboard.settings.deleteAccountFailed': 'Account deletion failed',
  'dashboard.settings.dataExportSuccess': 'Data exported successfully',
  'dashboard.settings.tabs.profile': 'Profile',
  'dashboard.settings.tabs.preferences': 'Preferences',
  'dashboard.settings.tabs.notifications': 'Notifications',
  'dashboard.settings.tabs.account': 'Account & Subscription',
  'dashboard.settings.profile.name': 'Name',
  'dashboard.settings.profile.email': 'Email',
  'dashboard.settings.profile.phone': 'Phone',
  'dashboard.settings.profile.avatarNote': 'Profile picture can be configured via update URL',
  'dashboard.settings.preferences.language': 'Language',
  'dashboard.settings.preferences.timezone': 'Time zone',
  'dashboard.settings.preferences.currency': 'Currency',
  'dashboard.settings.notifications.emailTitle': 'Email notifications',
  'dashboard.settings.notifications.pushTitle': 'Push notifications',
  'dashboard.settings.notifications.emailAnalysis.title': 'Analysis complete',
  'dashboard.settings.notifications.emailAnalysis.desc': 'Receive an email when your analysis is ready',
  'dashboard.settings.notifications.emailCredits.title': 'Credit updates',
  'dashboard.settings.notifications.emailCredits.desc': 'Notifications about credits and resets',
  'dashboard.settings.notifications.emailBilling.title': 'Invoices & payments',
  'dashboard.settings.notifications.emailBilling.desc': 'Notifications about invoices and subscription changes',
  'dashboard.settings.notifications.emailNewsletter.title': 'Newsletter',
  'dashboard.settings.notifications.emailNewsletter.desc': 'Tips, updates and new features',
  'dashboard.settings.notifications.pushAnalysis.title': 'Analysis complete',
  'dashboard.settings.notifications.pushAnalysis.desc': 'Browser notification when analysis is complete',
  'dashboard.settings.notifications.pushCredits.title': 'Credit warnings',
  'dashboard.settings.notifications.pushCredits.desc': 'Warning for low credit balance',
  'dashboard.settings.account.currentPlan': 'Current subscription',
  'dashboard.settings.account.plan': 'Plan',
  'dashboard.settings.account.price': 'Price',
  'dashboard.settings.account.moAbbrev': 'mo',
  'dashboard.settings.account.nextBilling': 'Next billing',
  'dashboard.settings.account.manageSubscription': 'Manage subscription & payments',
  'dashboard.settings.privacy.title': 'Data & privacy',
  'dashboard.settings.privacy.exportData': 'Export data',
  'dashboard.settings.privacy.deleteAccount': 'Delete account',
  'dashboard.settings.deleteModal.title': 'Delete account?',
  'dashboard.settings.deleteModal.subtitle': 'All data will be permanently deleted.',
  'dashboard.settings.deleteModal.point1': 'All analyses and data will be deleted',
  'dashboard.settings.deleteModal.point2': 'Active subscription will be cancelled immediately',
  'dashboard.settings.deleteModal.point3': 'No refunds possible',
  'dashboard.settings.deleteModal.typeKeyword': 'Type "{{keyword}}" *',

  // Subscription
  'dashboard.subscription.title': 'Subscription & Billing',
  'dashboard.subscription.subtitle': 'Manage your subscription and invoices',
  'dashboard.subscription.loadError': 'Failed to load subscription',
  'dashboard.subscription.cancelKeyword': 'CANCEL',
  'dashboard.subscription.cancelSuccess': 'Your subscription has been cancelled at the end of the billing period.',
  'dashboard.subscription.cancelFailed': 'Cancellation failed',
  'dashboard.subscription.reactivate': 'Reactivate',
  'dashboard.subscription.reactivateSuccess': 'Your subscription was reactivated successfully!',
  'dashboard.subscription.reactivateFailed': 'Reactivation failed',
  'dashboard.subscription.pauseSuccess': 'Your subscription has been paused.',
  'dashboard.subscription.pauseFailed': 'Pause failed',
  'dashboard.subscription.downgradePending': 'Downgrade is awaiting administrator approval.',
  'dashboard.subscription.downgradeRequested': 'Downgrade request submitted.',
  'dashboard.subscription.planChangedTo': 'Plan successfully changed to {{plan}}!',
  'dashboard.subscription.newPlan': 'new plan',
  'dashboard.subscription.planChangeFailed': 'Plan change failed',
  'dashboard.subscription.tabs.overview': 'Overview',
  'dashboard.subscription.tabs.billing': 'Billing address',
  'dashboard.subscription.tabs.history': 'Payment history',
  'dashboard.subscription.status.active': 'active',
  'dashboard.subscription.status.cancelled': 'cancelled',
  'dashboard.subscription.status.paused': 'paused',
  'dashboard.subscription.status.overdue': 'overdue',
  'dashboard.subscription.status.label': 'Status',
  'dashboard.subscription.memberSince': 'Member since {{date}}',
  'dashboard.subscription.chfBase': 'CHF {{amount}} base',
  'dashboard.subscription.monthAbbrev': 'month',
  'dashboard.subscription.creditsPerMonth': 'Credits / month',
  'dashboard.subscription.freeAccount': 'Free account',
  'dashboard.subscription.cancelSubscription': 'Cancel subscription',
  'dashboard.subscription.downloadInvoices': 'Download invoices',
  'dashboard.subscription.invoicesAvailable': '{{count}} invoices available as PDF',
  'dashboard.subscription.accountSettings': 'Account settings',
  'dashboard.subscription.accountSettingsDesc': 'Profile, notifications & more',
  'dashboard.subscription.billing.recipient': 'Billing recipient',
  'dashboard.subscription.billing.addressNote': 'Address changes are currently only available in your profile.',
  'dashboard.subscription.history.title': 'Payment history',
  'dashboard.subscription.history.subtitle': 'Download all invoices as PDF',
  'dashboard.subscription.history.downloadAll': 'Download all',
  'dashboard.subscription.history.eurNote': 'Invoices are always issued in CHF. EUR amounts shown are for reference only.',
  'dashboard.subscription.history.noInvoices': 'No invoices yet',
  'dashboard.subscription.history.col.date': 'Date',
  'dashboard.subscription.history.col.type': 'Type',
  'dashboard.subscription.history.col.net': 'Net',
  'dashboard.subscription.history.col.vat': 'VAT',
  'dashboard.subscription.history.col.total': 'Total',
  'dashboard.subscription.history.col.pdf': 'PDF',
  'dashboard.subscription.history.invoicesCount': '{{count}} invoices',
  'dashboard.subscription.history.totalAmount': 'Total amount',
  'dashboard.subscription.switching': 'Switching...',
  'dashboard.subscription.cancelling': 'Cancelling...',
  'dashboard.subscription.cancelNow': 'Cancel now',
  'dashboard.subscription.eurNotice.prefix': 'Prices are displayed in',
  'dashboard.subscription.eurNotice.currency': 'Euro',
  'dashboard.subscription.eurNotice.suffix': '',
  'dashboard.subscription.eurNotice.rate': 'Rate',
  'dashboard.subscription.eurNotice.currentRate': 'Current rate',
  'dashboard.subscription.eurChangePlanNote': 'Prices shown in EUR ({{note}}). Billing is in CHF.',
  'dashboard.subscription.cancelModal.title': 'Cancel subscription?',
  'dashboard.subscription.cancelModal.subtitle': 'Cancellation takes effect at the end of the billing period.',
  'dashboard.subscription.cancelModal.point1': 'No more credits after expiration',
  'dashboard.subscription.cancelModal.point2': 'Premium features will be removed',
  'dashboard.subscription.cancelModal.pauseTitle': 'Alternative: Pause subscription?',
  'dashboard.subscription.cancelModal.pauseDesc': 'Pause your subscription instead and keep your data.',
  'dashboard.subscription.cancelModal.pauseCta': 'Pause instead',
  'dashboard.subscription.cancelModal.reasonLabel': 'Cancellation reason',
  'dashboard.subscription.cancelModal.selectReason': 'Please select...',
  'dashboard.subscription.cancelModal.reasonTooExpensive': 'Too expensive',
  'dashboard.subscription.cancelModal.reasonNotUsing': 'Not using it enough',
  'dashboard.subscription.cancelModal.reasonMissing': 'Missing features',
  'dashboard.subscription.cancelModal.reasonAlternative': 'Found alternative',
  'dashboard.subscription.cancelModal.reasonOther': 'Other',
  'dashboard.subscription.cancelModal.confirmLabel': 'Confirmation: Type "{{keyword}}" *',
  'dashboard.subscription.invoice.heading': 'INVOICE',
  'dashboard.subscription.invoice.from': 'FROM',
  'dashboard.subscription.invoice.to': 'TO',
  'dashboard.subscription.invoice.vatId': 'VAT ID',
  'dashboard.subscription.invoice.date': 'Invoice date',
  'dashboard.subscription.invoice.number': 'Invoice number',
  'dashboard.subscription.invoice.paymentStatus': 'Payment status',
  'dashboard.subscription.invoice.description': 'DESCRIPTION',
  'dashboard.subscription.invoice.quantity': 'QTY',
  'dashboard.subscription.invoice.price': 'PRICE',
  'dashboard.subscription.invoice.amount': 'AMOUNT',
  'dashboard.subscription.invoice.subscriptionLabel': 'Subscription',
  'dashboard.subscription.invoice.subtotal': 'Subtotal',
  'dashboard.subscription.invoice.total': 'Total amount',
  'dashboard.subscription.invoice.downloaded': 'Invoice {{invoiceNo}} downloaded!',
  'dashboard.subscription.invoice.pdfError': 'Failed to create PDF.',

  // Dashboard — shared transaction status labels
  'dashboard.txStatus.completed': 'Completed',
  'dashboard.txStatus.pending': 'Pending',
  'dashboard.txStatus.failed': 'Failed',
  'dashboard.txStatus.active': 'Active',
  'dashboard.txStatus.cancelled': 'Cancelled',
  'dashboard.txStatus.refunded': 'Refunded',
  'dashboard.txStatus.paused': 'Paused',
  'dashboard.txStatus.overdue': 'Overdue',

  // Dashboard — shared transaction type labels
  'dashboard.txType.subscription': 'Subscription',
  'dashboard.txType.upgrade': 'Upgrade',
  'dashboard.txType.downgrade': 'Downgrade',
  'dashboard.txType.refund': 'Refund',
  'dashboard.txType.bonus': 'Bonus',
  'dashboard.txType.deduction': 'Deduction',
  'dashboard.txType.payment': 'Payment',
  'dashboard.txType.reset': 'Reset',
  'dashboard.txType.credit_purchase': 'Credit purchase',
  'dashboard.txType.plan_change': 'Plan change',

  // Email Verification Gate
  'dashboard.verify.title': 'Verify your email',
  'dashboard.verify.subtitle': 'One quick step to activate your account',
  'dashboard.verify.instruction': 'We sent a verification link to:',
  'dashboard.verify.hint':
    "Open the email and click the button to activate. This page will unlock automatically. Check your spam folder if you don't see it within a minute.",
  'dashboard.verify.checking': 'Checking…',
  'dashboard.verify.checkNow': "I've clicked the link",
  'dashboard.verify.sending': 'Sending…',
  'dashboard.verify.resend': 'Resend email',
  'dashboard.verify.skip': "I'll verify later",
  'dashboard.verify.logout': 'Log out',
  'dashboard.verify.autoCheck':
    'We check every 5 seconds — the page unlocks as soon as you verify.',
  'dashboard.verify.resendSuccess': 'Verification email sent to {{email}}.',
  'dashboard.verify.resendError': 'Could not resend. Try again in a moment.',

  // Analysis Card (AI analysis output card)
  'dashboard.analysisCard.creditsLabel_one': '{{count}} credit',
  'dashboard.analysisCard.creditsLabel_other': '{{count}} credits',
  'dashboard.analysisCard.creditsLabel': '{{count}} credits',
  'dashboard.analysisCard.industryBenchmark': 'Industry benchmark',
  'dashboard.analysisCard.topPercent': 'Top {{pct}}%',
  'dashboard.analysisCard.industryAvg': 'Industry avg',
  'dashboard.analysisCard.top10Percent': 'Top 10%',
  'dashboard.analysisCard.you': 'You',
  'dashboard.analysisCard.avgShort': 'Avg',
  'dashboard.analysisCard.competitorAnalysis': 'Competitor analysis',
  'dashboard.analysisCard.entryPoint': 'Your entry point',
  'dashboard.analysisCard.sources': 'Sources',
  'dashboard.analysisCard.creditsUsageTip_one':
    'This analysis used {{count}} credit · Tip: precise descriptions save credits',
  'dashboard.analysisCard.creditsUsageTip_other':
    'This analysis used {{count}} credits · Tip: precise descriptions save credits',
  'dashboard.analysisCard.creditsUsageTip':
    'This analysis used {{count}} credits · Tip: precise descriptions save credits',
  'dashboard.analysisCard.recheck': 'Recheck',
  'dashboard.analysisCard.metrics.demand': 'Demand',
  'dashboard.analysisCard.metrics.willingnessToPay': 'Willingness to pay',
  'dashboard.analysisCard.metrics.differentiation': 'Differentiation',
  'dashboard.analysisCard.metrics.feasibility': 'Feasibility',
  'dashboard.analysisCard.metrics.risk': 'Risk',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Welcome back, {{name}}',
  'dashboard.overview.subtitle':
    'Here is a quick overview of your activity',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Credits remaining',
  'dashboard.stats.totalAnalyses': 'Total analyses',
  'dashboard.stats.goodRatings': 'Positive ratings',
  'dashboard.stats.nextReset': 'Next reset in',
  'dashboard.stats.days': 'days',
  'dashboard.stats.loadError': 'Failed to load stats',

  // Quick Actions
  'dashboard.quickActions.title': 'Quick actions',
  'dashboard.quickActions.checkNewIdea': 'Check an idea',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analyze an existing business idea',
  'dashboard.quickActions.generateIdea': 'Generate an idea',
  'dashboard.quickActions.generateIdeaDesc':
    'Find a new profitable niche',
  'dashboard.quickActions.builderBriefing': 'Builder briefing',
  'dashboard.quickActions.builderBriefingDesc':
    'Turn an idea into a developer-ready briefing',
  'dashboard.quickActions.premiumOnly': 'Builder only',

  // Chat Header
  'chat.title': 'AI Niche Assistant',
  'chat.subtitle':
    'Ask questions about niches. I evaluate critically and honestly.',
  'chat.creditsLabel': 'Credits',

  // Chat Welcome
  'chat.welcomeTitle': 'Welcome to the AI Niche Assistant',
  'chat.welcomeDesc':
    'Describe your idea or ask about a niche. I will evaluate it honestly: Good, Average or Bad.',
  'chat.aiWelcome':
    'Hi! Describe your idea or ask me about a niche. I will give you a clear and honest evaluation.',

  // Chat Suggestions
  'chat.suggestion1': 'I want to build a SaaS tool for freelancers to manage invoices. Is this a good niche?',
  'chat.suggestion2': 'Find me a low-competition online business I can start with $500 and no coding skills.',
  'chat.suggestion3': 'Evaluate this: an AI-powered meal planning app for busy parents with dietary restrictions.',
  'chat.suggestion4': 'I want to sell digital templates on Etsy for small business owners. Analyze this niche honestly.',
  'chat.suggestion5': 'Is a niche newsletter for solo real-estate agents in small cities a viable business?',
  'chat.suggestion6': 'Give me three under-served B2B niches where software barely exists today.',
  'chat.suggestion7': 'I have an idea for a subscription box targeting new dads. Evaluate the numbers honestly.',
  'chat.suggestion8': 'Which profitable micro-SaaS ideas can I build solo in under 90 days?',
  'chat.suggestion9': 'Evaluate this: a mobile app that turns voice notes into structured sales CRM entries.',
  'chat.suggestion10': 'I want to launch an online coaching program for Gen-Z freelancers. Good niche or saturated?',
  'chat.suggestion11': 'Analyze a done-for-you LinkedIn content service for B2B founders at 1,500 $/mo.',
  'chat.suggestion12': 'Find me a boring niche with recurring revenue and low marketing costs.',

  // Chat Actions
  'chat.newConversation': 'New conversation',
  'chat.today': 'Today',
  'chat.yesterday': 'Yesterday',
  'chat.thisWeek': 'This week',
  'chat.thisMonth': 'This month',
  'chat.older': 'Older',
  'chat.messages': 'messages',
  'chat.renameConversation': 'Rename',
  'chat.deleteConversation': 'Delete',
  'chat.cancel': 'Cancel',
  'chat.rename': 'Rename',
  'chat.delete': 'Delete',
  'chat.favorite': 'Add favorite',
  'chat.unfavorite': 'Remove favorite',
  'chat.searchSessions': 'Search conversations...',
  'chat.noResults': 'No results found',
  'chat.noSessions': 'No conversations yet',
  'chat.enterNewName': 'Enter new name...',
  'chat.deleteConfirmMessage':
    'Are you sure you want to delete this conversation? This action cannot be undone.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Type your question… (costs 30 credits)',
  'chat.send': 'Send',
  'chat.voice': 'Speak',
  'chat.errorNotEnoughCredits':
    'Not enough credits. Please upgrade your plan or wait for the next reset.',
  'chat.errorAiFailed': 'AI response failed. No credits were deducted.',
  'chat.errorRateLimit': 'Too many requests. Please wait a moment.',

  // Ratings
  'rating.good': 'Good',
  'rating.medium': 'Average',
  'rating.bad': 'Bad',

  // Auth Page
  'auth.branding.headline1': 'Not every idea is good.',
  'auth.branding.headline2': 'We tell you honestly.',
  'auth.branding.subtitle':
    'A decision AI for business niches. Clear. Critical. No sugarcoating.',
  'auth.benefits.privacy.title': '100% Private',
  'auth.benefits.privacy.desc':
    'Your ideas stay completely private and secure.',
  'auth.benefits.honest.title': 'Honest AI',
  'auth.benefits.honest.desc':
    'No sugarcoating – just clear, critical feedback.',
  'auth.benefits.fast.title': 'Fast Results',
  'auth.benefits.fast.desc': 'Get clarity about your niche in minutes.',
  'auth.trust.users': 'Active Users',
  'auth.trust.ideas': 'Ideas Analyzed',
  'auth.trust.rating': 'User Rating',
  'auth.login.title': 'Login',
  'auth.login.headline': 'Welcome back',
  'auth.login.subtitle': 'Sign in to continue your journey.',
  'auth.login.forgotPassword': 'Forgot password?',
  'auth.login.submit': 'Sign In',
  'auth.login.noAccount': 'No account yet?',
  'auth.login.signUp': 'Sign up',
  'auth.register.title': 'Register',
  'auth.register.headline': 'Create your account',
  'auth.register.subtitle':
    'Start analyzing your business ideas today.',
  'auth.register.submit': 'Create Account',
  'auth.register.hasAccount': 'Already have an account?',
  'auth.register.signIn': 'Sign in',
  'auth.fields.name': 'Full Name',
  'auth.fields.email': 'Email Address',
  'auth.fields.password': 'Password',
  'auth.fields.confirmPassword': 'Confirm Password',
  'auth.fields.selectPlan': 'Select your plan',
  'auth.placeholders.name': 'Enter your name',
  'auth.placeholders.email': 'Enter your email',
  'auth.placeholders.password': 'Enter your password',
  'auth.placeholders.confirmPassword': 'Confirm your password',
  'auth.terms.accept': 'I accept the',
  'auth.terms.terms': 'Terms & Conditions',
  'auth.privacy.accept': 'I accept the',
  'auth.privacy.policy': 'Privacy Policy',
  'auth.errors.nameRequired': 'Name is required',
  'auth.errors.emailRequired': 'Email is required',
  'auth.errors.emailInvalid': 'Please enter a valid email',
  'auth.errors.passwordRequired': 'Password is required',
  'auth.errors.passwordLength': 'Password must be at least 8 characters',
  'auth.errors.passwordMismatch': 'Passwords do not match',
  'auth.errors.network': 'Could not reach the server. Please try again or use email registration.',
  'auth.errors.appleUnavailable': 'Apple sign-in is temporarily unavailable. Please register with your email instead.',
  'auth.loading': 'Please wait...',
  'auth.or': 'or continue with',
  'auth.social.google': 'Continue with Google',
  'auth.social.apple': 'Continue with Apple',

  // Email Verification
  'auth.verification.title': 'Verify Email',
  'auth.verification.headline': 'Check your inbox',
  'auth.verification.subtitle': 'We sent a verification code to:',
  'auth.verification.codeLabel': 'Verification Code',
  'auth.verification.codePlaceholder': 'Enter 6-digit code',
  'auth.verification.submit': 'Verify Email',
  'auth.verification.resend': 'Resend code',
  'auth.verification.resendIn': 'Resend in',
  'auth.verification.seconds': 'seconds',
  'auth.verification.success': 'Email verified successfully!',
  'auth.verification.error': 'Invalid code. Please try again.',
  'auth.verification.expired': 'Code expired. Please request a new one.',
  'auth.verification.sent': 'New code sent!',
  'auth.verification.checkSpam':
    "Didn't receive it? Check your spam folder.",

  // Forgot Password
  'auth.forgot.title': 'Forgot Password',
  'auth.forgot.headline': 'Reset your password',
  'auth.forgot.subtitle':
    "Enter your email address and we'll send you a reset link.",
  'auth.forgot.submit': 'Send Reset Link',
  'auth.forgot.backToLogin': 'Back to login',
  'auth.forgot.success': 'Email sent!',
  'auth.forgot.successMessage':
    "We've sent you an email with instructions to reset your password.",
  'auth.forgot.checkInbox': 'Check your inbox',

  // Reset Password
  'auth.reset.title': 'New Password',
  'auth.reset.headline': 'Set new password',
  'auth.reset.subtitle': 'Enter your new password.',
  'auth.reset.newPassword': 'New Password',
  'auth.reset.confirmNewPassword': 'Confirm New Password',
  'auth.reset.submit': 'Change Password',
  'auth.reset.success': 'Password changed successfully!',
  'auth.reset.successMessage':
    'You can now sign in with your new password.',
  'auth.reset.loginNow': 'Sign in now',

  // Legal Pages
  'legal.backToAuth': 'Back to login',
  'legal.allRightsReserved': 'All rights reserved.',

  // Terms Page
  'legal.terms.title': 'Terms and Conditions',
  'legal.terms.lastUpdated': 'Last updated',
  'legal.terms.section1.title': '1. Scope',
  'legal.terms.section1.content':
    'These Terms and Conditions apply to all contracts between NicheFinder (hereinafter "Provider") and the user (hereinafter "Customer") regarding the use of the AI-powered niche analysis platform.',
  'legal.terms.section2.title': '2. Service Description',
  'legal.terms.section2.content':
    'The Provider offers an AI-based platform that analyzes and evaluates business ideas and niches. Services include:',
  'legal.terms.section2.item1': 'AI-powered analysis of business ideas',
  'legal.terms.section2.item2': 'Evaluation of market potential and competition',
  'legal.terms.section2.item3': 'Generation of niche suggestions',
  'legal.terms.section2.item4': 'Creation of developer briefings (Builder package)',
  'legal.terms.section3.title': '3. Contract Conclusion and Registration',
  'legal.terms.section3.content':
    'The contract is concluded through registration on the platform and selection of a package. The customer confirms:',
  'legal.terms.section3.item1': 'Being of legal age and fully legally competent',
  'legal.terms.section3.item2': 'Providing truthful information during registration',
  'legal.terms.section3.item3': 'Secure storage of access credentials',
  'legal.terms.section4.title': '4. Credits and Billing',
  'legal.terms.section4.content':
    'The use of AI features is based on a credit system. Each AI query costs 30 credits. Credits are only deducted upon successful response. Unused credits expire at the end of the billing period and are not refunded.',
  'legal.terms.section5.title': '5. Disclaimer',
  'legal.terms.section5.content':
    'AI evaluations serve solely as decision-making aids and do not guarantee business success. The Provider is not liable for decisions made based on AI analyses. Liability for intent and gross negligence remains unaffected.',
  'legal.terms.section6.title': '6. Data Protection and Confidentiality',
  'legal.terms.section6.content':
    'All submitted business ideas are treated confidentially and not shared with third parties. Processing of personal data is carried out in accordance with our Privacy Policy and applicable data protection laws.',
  'legal.terms.section7.title': '7. Termination',
  'legal.terms.section7.content':
    'The customer may cancel their subscription at any time at the end of the current billing period. In case of violations of these Terms, the Provider reserves the right to block access to the platform.',
  'legal.terms.section8.title': '8. Final Provisions',
  'legal.terms.section8.content':
    'Swiss law applies. Place of jurisdiction is Zurich, Switzerland. Should individual provisions of these Terms be invalid, the validity of the remaining provisions remains unaffected.',
  'legal.terms.contact.title': 'Questions about the Terms?',
  'legal.terms.contact.content':
    'If you have questions about these Terms and Conditions, please contact us at:',

  // Privacy Page
  'legal.privacy.title': 'Privacy Policy',
  'legal.privacy.section1.title': '1. Data Controller',
  'legal.privacy.section1.content':
    'The data controller for this website is NicheFinder, Zurich, Switzerland. We take the protection of your personal data very seriously and treat your personal data confidentially and in accordance with statutory data protection regulations.',
  'legal.privacy.section2.title': '2. Data Collected',
  'legal.privacy.section2.content':
    'We collect and process the following personal data:',
  'legal.privacy.section2.item1':
    'Registration data: Name, email address, password (encrypted)',
  'legal.privacy.section2.item2':
    'Usage data: IP address, browser type, access times',
  'legal.privacy.section2.item3':
    'Business ideas and niche queries (stored anonymously)',
  'legal.privacy.section2.item4':
    'Payment information (via secure third-party providers)',
  'legal.privacy.section3.title': '3. Purpose of Data Processing',
  'legal.privacy.section3.content':
    'Your data is used for the following purposes:',
  'legal.privacy.section3.item1':
    'Provision and improvement of our AI services',
  'legal.privacy.section3.item2':
    'Account management and authentication',
  'legal.privacy.section3.item3':
    'Billing and payment processing',
  'legal.privacy.section4.title': '4. Data Security',
  'legal.privacy.section4.content':
    'We implement technical and organizational security measures to protect your data against manipulation, loss, destruction, or unauthorized access. All data transfers are encrypted via SSL/TLS.',
  'legal.privacy.section5.title': '5. Confidentiality of Your Business Ideas',
  'legal.privacy.section5.content':
    'Your submitted business ideas and niche queries are treated strictly confidentially. They are not shared with third parties, not used for training purposes, and can be completely deleted upon request. Your ideas belong to you.',
  'legal.privacy.section6.title': '6. Your Rights',
  'legal.privacy.section6.content':
    'You have the following rights regarding your personal data:',
  'legal.privacy.section6.item1': 'Right to access stored data',
  'legal.privacy.section6.item2': 'Right to rectification of inaccurate data',
  'legal.privacy.section6.item3': 'Right to deletion of your data',
  'legal.privacy.section6.item4': 'Right to data portability',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content':
    'Our website only uses technically necessary cookies for authentication and session management. We do not use tracking cookies or third-party analytics tools without your explicit consent.',
  'legal.privacy.section8.title': '8. Changes to this Privacy Policy',
  'legal.privacy.section8.content':
    'We reserve the right to adapt this privacy policy to comply with changed legal requirements or when changes to the service occur. The current version can always be found on this page.',
  'legal.privacy.contact.title': 'Questions about Privacy?',
  'legal.privacy.contact.content':
    'If you have questions about the processing of your personal data, please contact us at:',

  passwordStrength: {
    label: 'Password strength',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    veryStrong: 'Very strong',
    minLength: 'Min. 8 characters',
    uppercase: 'Uppercase letter',
    number: 'Number',
    special: 'Special character',
  },

  trial: {
    subtitle: 'Free Trial',
    upgrade: 'Upgrade Now',
    creditsRemaining: 'credits remaining',
    inputHint: 'Trial version - No conversation history available',
    banner: {
      title: '7-Day Trial Active',
      remaining: '{{days}} days remaining',
      credits: 'credits available',
      upgradeNow: 'Upgrade Now',
    },
    welcome: {
      title: 'Welcome to the Free Trial!',
      desc: 'Test our AI assistant for 7 days free with 100 credits. Ask questions and discover the possibilities!',
    },
    info: {
      title: 'Trial Limitations',
      credits: '100 credits for 7 days',
      noHistory: 'No conversation history',
      noSettings: 'Limited features',
      upgrade: 'Upgrade for full features',
    },
  },

  // Admin Dashboard
  'admin.common.all': 'All',
  'admin.common.cancel': 'Cancel',
  'admin.common.save': 'Save',
  'admin.common.saving': 'Saving...',
  'admin.common.loading': 'Loading...',
  'admin.common.create': 'Create',
  'admin.common.edit': 'Edit',
  'admin.common.delete': 'Delete',
  'admin.common.close': 'Close',
  'admin.common.back': 'Back',
  'admin.common.next': 'Next',
  'admin.common.change': 'Change',
  'admin.common.error': 'Error',

  // Admin Login
  'admin.login.adminLogin': 'Admin Login',
  'admin.login.emailLabel': 'Admin Email',
  'admin.login.passwordLabel': 'Admin Password',
  'admin.login.notAdminAccount': 'This is not an admin account.',
  'admin.login.invalidCredentials': 'Invalid admin credentials. Please check your email and password.',
  'admin.login.signingIn': 'Signing in...',
  'admin.login.submit': 'Sign in as Admin',
  'admin.login.backToHome': 'Back to homepage',
  'admin.login.securityNotice': 'All admin activities are logged',

  // Admin Header
  'admin.header.title': 'Admin Dashboard',
  'admin.header.subtitle': 'Control Center',
  'admin.header.superAdmin': 'Super Admin',
  'admin.header.logout': 'Sign out',

  // Admin Dashboard Tabs
  'admin.dashboard.tabs.users': 'User Management',
  'admin.dashboard.tabs.downgrades': 'Downgrades',
  'admin.dashboard.tabs.tips': 'Tip of the Day',
  'admin.dashboard.tabs.coupons': 'Coupon Codes',
  'admin.dashboard.tabs.website': 'Website Editor',
  'admin.dashboard.tabs.ai': 'AI Settings',
  'admin.dashboard.tabs.transactions': 'Transaction Log',
  'admin.dashboard.tabs.stats': 'Statistics',
  'admin.dashboard.tabs.usage': 'Usage',

  // Admin Stats
  'admin.stats.loadError': 'Failed to load statistics',
  'admin.stats.noData': 'No statistics available',
  'admin.stats.totalUsers': 'Total users',
  'admin.stats.revenue30d': 'Revenue (30 days)',
  'admin.stats.activeSubs': 'Active subscriptions',
  'admin.stats.average': 'Average',
  'admin.stats.revenuePerUser': 'Revenue per user',
  'admin.stats.totalRevenue': 'Total revenue',
  'admin.stats.ideasTotal': 'Ideas analyzed',
  'admin.stats.pausedSubs': 'Paused subscriptions',
  'admin.stats.churnRate': 'Churn rate',
  'admin.stats.planDistribution': 'Plan distribution',
  'admin.stats.usersCount': '{{count}} users',
  'admin.stats.revenueByPlan': 'Revenue by plan',
  'admin.stats.subStatusOverview': 'Subscription status overview',
  'admin.stats.statusActive': 'Active',
  'admin.stats.statusCancelled': 'Cancelled',
  'admin.stats.statusPaused': 'Paused',
  'admin.stats.statusOverdue': 'Overdue',
  'admin.stats.couponStats': 'Coupon statistics',
  'admin.stats.totalRedemptions': 'Total redemptions',
  'admin.stats.activeCoupons': 'Active coupons',
  'admin.stats.registrationRedemptions': 'Registration redemptions',
  'admin.stats.trialRedemptions': 'Trial redemptions',
  'admin.stats.couponDistribution': 'Coupon distribution',
  'admin.stats.registrationCoupons': 'Registration coupons',
  'admin.stats.trialCoupons': 'Trial coupons',
  'admin.stats.expiredInactive': 'Expired/Inactive',
  'admin.stats.topCoupons': 'Top coupons by redemptions',
  'admin.stats.redemptions': 'Redemptions',
  'admin.stats.noCouponsRedeemed': 'No coupons redeemed yet',

  // Admin Users
  'admin.users.loadError': 'Failed to load users',
  'admin.users.searchPlaceholder': 'Search users (email or name)...',
  'admin.users.allPlans': 'All plans',
  'admin.users.colUser': 'User',
  'admin.users.colPlan': 'Plan',
  'admin.users.colStatus': 'Subscription status',
  'admin.users.colCredits': 'Credits',
  'admin.users.colRegistered': 'Registered',
  'admin.users.colActions': 'Actions',
  'admin.users.statusActive': 'Active',
  'admin.users.statusCancelled': 'Cancelled',
  'admin.users.statusPaused': 'Paused',
  'admin.users.statusOverdue': 'Overdue',
  'admin.users.statusNone': 'No subscription',
  'admin.users.free': 'Free',
  'admin.users.adminBadge': 'Admin',
  'admin.users.unlimited': 'Unlimited',
  'admin.users.viewDetails': 'View details',
  'admin.users.changePlan': 'Change plan',
  'admin.users.grantCredits': 'Grant credits',
  'admin.users.revokeFree': 'Remove free status',
  'admin.users.grantFree': 'Grant free access',
  'admin.users.grantFreeTitle': 'Grant free access',
  'admin.users.unblock': 'Unblock',
  'admin.users.block': 'Block',
  'admin.users.unblockTitle': 'Unblock user',
  'admin.users.blockTitle': 'Block user',
  'admin.users.unblockMessage': 'The user will be able to sign in again.',
  'admin.users.blockMessage': 'The user will be logged out and will not be able to sign in.',
  'admin.users.blockedSuccess': '{{name}} has been blocked',
  'admin.users.unblockedSuccess': '{{name}} has been unblocked',
  'admin.users.blockError': 'Failed to block user',
  'admin.users.confirmRevokeFree': 'Remove free status for {{name}}?',
  'admin.users.revokedFreeSuccess': 'Free status removed for {{name}}',
  'admin.users.grantedFreeSuccess': '{{name}} now has {{duration}} {{unit}} of free access',
  'admin.users.grantError': 'Failed to grant',
  'admin.users.daysUnit': 'day(s)',
  'admin.users.monthsUnit': 'month(s)',
  'admin.users.duration': 'Duration',
  'admin.users.days': 'Days',
  'admin.users.months': 'Months',
  'admin.users.grantSubmit': 'Grant',
  'admin.users.planChangedSuccess': 'Changed {{name}} to {{plan}}',
  'admin.users.planChangeError': 'Failed to change plan',
  'admin.users.newPlan': 'New plan',
  'admin.users.creditsPerMonth': '{{credits}} credits/month',
  'admin.users.creditsGrantedSuccess': '{{count}} credits granted to {{name}}',
  'admin.users.creditGrantSubmit': 'Grant',
  'admin.users.amount': 'Amount',
  'admin.users.credits': 'Credits',
  'admin.users.current': 'Current',
  'admin.users.currentPlan': 'Current plan',
  'admin.users.status': 'Status',
  'admin.users.subInfo': 'Subscription information',
  'admin.users.noUsers': 'No users found.',
  'admin.users.total': 'Total: {{count}} users',
  'admin.users.activeCount': '{{count}} active',
  'admin.users.cancelledCount': '{{count}} cancelled',
  'admin.users.freeAccess': 'Free access',
  'admin.users.validUntil': 'Valid until',
  'admin.users.validUntilLabel': 'Valid until',
  'admin.users.cancelled': 'Subscription cancelled',
  'admin.users.cancelledDate': 'Cancellation date',
  'admin.users.reason': 'Reason',
  'admin.users.contact': 'Contact',
  'admin.users.verified': 'Verified',
  'admin.users.notVerified': 'Not verified',

  // Admin Coupons
  'admin.coupons.loadError': 'Failed to load coupons',
  'admin.coupons.fillRequired': 'Please fill in all required fields',
  'admin.coupons.chooseExpiry': 'Please choose an expiry date or enable "No expiry"',
  'admin.coupons.createError': 'Failed to create',
  'admin.coupons.confirmDelete': 'Delete this coupon?',
  'admin.coupons.deleteError': 'Failed to delete',
  'admin.coupons.updateError': 'Failed to update',
  'admin.coupons.allPlans': 'All plans',
  'admin.coupons.percentDiscount': '{{pct}}% discount',
  'admin.coupons.credits': 'Credits',
  'admin.coupons.days': 'Days',
  'admin.coupons.months': 'Months',
  'admin.coupons.free': 'free',
  'admin.coupons.title': 'Coupon management',
  'admin.coupons.subtitle': 'Create and manage coupon codes',
  'admin.coupons.newCoupon': 'New coupon',
  'admin.coupons.registrationTab': 'Registration coupons',
  'admin.coupons.trialTab': 'Trial coupons',
  'admin.coupons.typeRegistration': 'Registration',
  'admin.coupons.typeTrial': 'Trial access',
  'admin.coupons.colStatus': 'Status',
  'admin.coupons.colCode': 'Code',
  'admin.coupons.colType': 'Type',
  'admin.coupons.colPlan': 'Plan',
  'admin.coupons.colValue': 'Value',
  'admin.coupons.colUsage': 'Usage',
  'admin.coupons.colValidUntil': 'Valid until',
  'admin.coupons.colActions': 'Actions',
  'admin.coupons.colCredits': 'Credits',
  'admin.coupons.colDuration': 'Duration',
  'admin.coupons.copyCode': 'Copy code',
  'admin.coupons.unlimited': 'Unlimited',
  'admin.coupons.noRegistrationCoupons': 'No registration coupons yet.',
  'admin.coupons.noTrialCoupons': 'No trial coupons yet.',
  'admin.coupons.createRegistrationTitle': 'Create registration coupon',
  'admin.coupons.createTrialTitle': 'Create trial coupon',
  'admin.coupons.labelCode': 'Coupon code *',
  'admin.coupons.codePlaceholder': 'e.g. NF-7X3K9M',
  'admin.coupons.generateCode': 'Generate new code',
  'admin.coupons.labelType': 'Type *',
  'admin.coupons.typeDiscount': 'Discount',
  'admin.coupons.typeCredits': 'Credits',
  'admin.coupons.typeUniversal': 'Universal',
  'admin.coupons.labelPlan': 'Plan',
  'admin.coupons.planAllUniversal': 'All plans (Universal)',
  'admin.coupons.planStarter': 'Starter only',
  'admin.coupons.planPro': 'Pro only',
  'admin.coupons.planBuilder': 'Builder only',
  'admin.coupons.labelDiscountPct': 'Discount % (optional)',
  'admin.coupons.discountPlaceholder': 'e.g. 50 for 50% off',
  'admin.coupons.labelBonusCredits': 'Bonus credits (optional)',
  'admin.coupons.bonusCreditsPlaceholder': 'e.g. 500',
  'admin.coupons.labelFreeDuration': 'Free duration (optional)',
  'admin.coupons.durationPlaceholder': 'e.g. 30',
  'admin.coupons.unlimitedUses': 'Unlimited redemptions',
  'admin.coupons.unlimitedUsesDesc': 'No usage limit',
  'admin.coupons.labelMaxUses': 'Maximum redemptions',
  'admin.coupons.labelMaxUsesRequired': 'Maximum redemptions *',
  'admin.coupons.noExpiry': 'No expiry',
  'admin.coupons.noExpiryDesc': 'No expiry date',
  'admin.coupons.labelValidUntil': 'Valid until',
  'admin.coupons.labelCredits': 'Credits *',
  'admin.coupons.creditsPlaceholder': 'e.g. 100',
  'admin.coupons.labelTrialDuration': 'Trial duration *',
  'admin.coupons.trialDurationPlaceholder': 'e.g. 7',
  'admin.coupons.autoCalcExpiry': 'Automatically calculated from trial duration',

  // Admin Downgrades
  'admin.downgrades.loadError': 'Failed to load',
  'admin.downgrades.confirmApprove': 'Approve downgrade request from {{user}}?',
  'admin.downgrades.confirmReject': 'Really reject this downgrade request?',
  'admin.downgrades.approveError': 'Failed to approve',
  'admin.downgrades.rejectError': 'Failed to reject',
  'admin.downgrades.statusPending': 'Pending',
  'admin.downgrades.statusApproved': 'Approved',
  'admin.downgrades.statusRejected': 'Rejected',
  'admin.downgrades.sectionRequests': 'Requests',
  'admin.downgrades.sectionStats': 'Statistics',
  'admin.downgrades.sectionReports': 'Reports',
  'admin.downgrades.pendingRequests': 'Pending requests',
  'admin.downgrades.approvedRequests': 'Approved requests',
  'admin.downgrades.rejectedRequests': 'Rejected requests',
  'admin.downgrades.refundsApproved': 'Refunds (approved)',
  'admin.downgrades.noRequests': 'No requests found',
  'admin.downgrades.user': 'User',
  'admin.downgrades.refund': 'Refund',
  'admin.downgrades.approve': 'Approve',
  'admin.downgrades.reject': 'Reject',
  'admin.downgrades.range7d': '7 days',
  'admin.downgrades.range30d': '30 days',
  'admin.downgrades.range90d': '90 days',
  'admin.downgrades.range1y': '1 year',
  'admin.downgrades.totalRequests': 'Total requests',
  'admin.downgrades.approvalRate': 'Approval rate',
  'admin.downgrades.requestsPerMonth': 'Requests per month',
  'admin.downgrades.monthApproved': '{{count}} approved',
  'admin.downgrades.monthRejected': '{{count}} rejected',
  'admin.downgrades.monthPending': '{{count}} pending',
  'admin.downgrades.topReasons': 'Top cancellation reasons',
  'admin.downgrades.noReasons': 'No reasons recorded',
  'admin.downgrades.planTransitions': 'Plan transitions',
  'admin.downgrades.noTransitions': 'No transitions',
  'admin.downgrades.exportReport': 'Export report',
  'admin.downgrades.exportDescription': 'Export {{count}} requests from the selected range',
  'admin.downgrades.asCsv': 'As CSV',
  'admin.downgrades.asJson': 'As JSON',
  'admin.downgrades.export.id': 'ID',
  'admin.downgrades.export.userId': 'User ID',
  'admin.downgrades.export.fromPlan': 'From plan',
  'admin.downgrades.export.toPlan': 'To plan',
  'admin.downgrades.export.reason': 'Reason',
  'admin.downgrades.export.refund': 'Refund',
  'admin.downgrades.export.date': 'Date',
  'admin.downgrades.export.status': 'Status',

  // Admin Downgrade Modal
  'admin.downgradeModal.title': 'Downgrade user',
  'admin.downgradeModal.createError': 'Failed to create',
  'admin.downgradeModal.requestCreated': 'Request created!',
  'admin.downgradeModal.requestCreatedDesc': 'The downgrade request was created successfully and is waiting for approval.',
  'admin.downgradeModal.closing': 'Closing...',
  'admin.downgradeModal.currentPlan': 'Current plan',
  'admin.downgradeModal.creditsPerMonth': '{{credits}} credits/month',
  'admin.downgradeModal.price': 'Price',
  'admin.downgradeModal.availablePlans': 'Available plans for downgrade',
  'admin.downgradeModal.noLowerPlans': 'No lower plans available.',
  'admin.downgradeModal.perMonth': 'per month',
  'admin.downgradeModal.refundAmount': 'Refund amount (CHF)',
  'admin.downgradeModal.refundHint': 'Optional. Leave empty or 0 for no refund.',
  'admin.downgradeModal.reasonOptional': 'Reason (optional)',
  'admin.downgradeModal.infoNotice': 'The downgrade request will be created and must still be approved. After approval, the plan is switched and the refund is processed.',
  'admin.downgradeModal.creating': 'Creating...',
  'admin.downgradeModal.createRequest': 'Create request',

  // Admin Transactions
  'admin.transactions.loadError': 'Failed to load transactions',
  'admin.transactions.validAmountRequired': 'Please enter a valid amount',
  'admin.transactions.refundError': 'Refund failed',
  'admin.transactions.typeUpgrade': 'Upgrade',
  'admin.transactions.typeDowngrade': 'Downgrade',
  'admin.transactions.typeSubscription': 'Subscription',
  'admin.transactions.typeRefund': 'Refund',
  'admin.transactions.typeBonus': 'Bonus',
  'admin.transactions.allStatus': 'All status',
  'admin.transactions.status_completed': 'Completed',
  'admin.transactions.status_pending': 'Pending',
  'admin.transactions.status_failed': 'Failed',
  'admin.transactions.noTransactions': 'No transactions found',
  'admin.transactions.userId': 'User ID',
  'admin.transactions.invoice': 'Invoice',
  'admin.transactions.includingVat': 'incl. CHF {{amount}} VAT',
  'admin.transactions.refund': 'Refund',
  'admin.transactions.pageOf': 'Page {{page}} of {{total}} ({{count}} transactions)',
  'admin.transactions.issueRefund': 'Issue refund',
  'admin.transactions.transaction': 'Transaction',
  'admin.transactions.original': 'Original',
  'admin.transactions.amount': 'Amount (CHF)',
  'admin.transactions.reasonOptional': 'Reason (optional)',
  'admin.transactions.refunding': 'Refunding...',
  'admin.transactions.issueRefundBtn': 'Refund',

  // Admin Tips
  'admin.tips.loadError': 'Failed to load tips',
  'admin.tips.createError': 'Failed to create',
  'admin.tips.updateError': 'Failed to update',
  'admin.tips.saveError': 'Failed to save',
  'admin.tips.confirmDelete': 'Really delete this tip?',
  'admin.tips.deleteError': 'Failed to delete',
  'admin.tips.title': 'Tip of the day',
  'admin.tips.subtitle': 'Create and manage tips shown to all users',
  'admin.tips.active': 'Active',
  'admin.tips.activeNotice': 'This tip is currently shown to all users',
  'admin.tips.createNew': 'Create new tip',
  'admin.tips.generating': 'Generating...',
  'admin.tips.sampleTip': 'Sample tip',
  'admin.tips.category': 'Category',
  'admin.tips.content': 'Content',
  'admin.tips.contentPlaceholder': 'Write your tip for the users here...',
  'admin.tips.addTip': 'Add tip',
  'admin.tips.allTips': 'All tips ({{count}})',
  'admin.tips.noTips': 'No tips created yet',
  'admin.tips.activate': 'Activate',
  'admin.tips.deactivate': 'Deactivate',
  'admin.tips.categoryFeature': 'New feature',
  'admin.tips.categoryProductivity': 'Productivity',
  'admin.tips.categoryUpdate': 'Update',
  'admin.tips.categoryTip': 'Tip',

  // Admin Website Editor
  'admin.website.title': 'Website editor',
  'admin.website.subtitle': 'Edit homepage',
  'admin.website.preview': 'Preview',
  'admin.website.editTextsFor': 'Editing texts for:',
  'admin.website.changeLanguage': 'Change language',
  'admin.website.groupStructure': 'Page structure',
  'admin.website.groupDesign': 'Design & layout',
  'admin.website.groupSettings': 'Settings',
  'admin.website.tabNavbar': 'Navigation',
  'admin.website.tabHero': 'Hero',
  'admin.website.tabFeatures': 'Features',
  'admin.website.tabHowItWorks': 'How it works',
  'admin.website.tabTestimonials': 'Testimonials',
  'admin.website.tabAbout': 'About us',
  'admin.website.tabPricing': 'Pricing',
  'admin.website.tabFaq': 'FAQ',
  'admin.website.tabCta': 'CTA',
  'admin.website.tabFooter': 'Footer',
  'admin.website.tabDesign': 'Design',
  'admin.website.tabSections': 'Sections',
  'admin.website.tabMedia': 'Media',
  'admin.website.tabCustomCode': 'Custom code',
  'admin.website.tabChatWidget': 'Talk with Us',
  'admin.website.tabInvoice': 'Invoices',
  'admin.website.tabSocials': 'Social media',
  'admin.website.tabLegal': 'Legal',
  'admin.website.tabSeo': 'SEO basic',
  'admin.website.tabAdvancedSeo': 'SEO advanced',
  'admin.website.tabVersions': 'Versions',
  'admin.website.tabImportExport': 'Import/Export',

  // Admin AI Settings
  'admin.aiSettings.saveError': 'Failed to save AI settings',
  'admin.aiSettings.title': 'AI assistant settings',
  'admin.aiSettings.subtitle': 'Configure behavior, style and analysis depth',
  'admin.aiSettings.modelRouting': 'Model routing',
  'admin.aiSettings.modelRoutingDesc': 'Pick the right model per task. Unavailable providers fall back to OpenAI automatically.',
  'admin.aiSettings.enableWebSearch': 'Enable web search (competitor + market data)',
  'admin.aiSettings.ready': 'ready',
  'admin.aiSettings.noKey': 'no key',
  'admin.aiSettings.tavilyReady': 'Tavily: ready',
  'admin.aiSettings.taskReady': '✓ ready',
  'admin.aiSettings.taskFallsBack': '⚠ falls back',
  'admin.aiSettings.intelligentWeightingTitle': 'Intelligent weighting active',
  'admin.aiSettings.intelligentWeightingDesc': 'The AI automatically combines all perspectives with intelligent weighting. With multiple templates, the first is weighted more heavily (primary template). You can also adjust the weighting manually.',
  'admin.aiSettings.recommendationsTitle': '💡 Recommendations for optimal results',
  'admin.aiSettings.newBadge': 'NEW',
  'admin.aiSettings.recommendationsDesc': 'Proven template combinations for best analysis quality',
  'admin.aiSettings.recommendationsInfo': 'These combinations have been tested and deliver the best results. Click a recommendation to apply it directly.',
  'admin.aiSettings.activeBadge': 'ACTIVE',
  'admin.aiSettings.apply': 'Apply',
  'admin.aiSettings.avoid': 'Avoid',
  'admin.aiSettings.qualityExcellent': 'Excellent quality',
  'admin.aiSettings.qualityGood': 'Good quality',
  'admin.aiSettings.qualityPoor': 'Diluted quality — not recommended',
  'admin.aiSettings.proTips': 'Pro tips',
  'admin.aiSettings.manyPresetsTitle': 'Warning: many templates',
  'admin.aiSettings.manyPresetsDesc': 'You have {{count}} templates selected. This may dilute the result. Recommended: 2-3 templates max for optimal results.',
  'admin.aiSettings.presets': 'Templates',
  'admin.aiSettings.multiSelect': '(multi-select enabled)',
  'admin.aiSettings.presetsDesc': 'Choose one or more templates. The first template is the primary one with highest weighting.',
  'admin.aiSettings.primaryPreset': 'Primary template',
  'admin.aiSettings.weightControl': 'Weighting control',
  'admin.aiSettings.weightControlDesc': 'Adjust how strongly each template influences the analysis',
  'admin.aiSettings.manual': 'Manual',
  'admin.aiSettings.automatic': 'Automatic',
  'admin.aiSettings.autoWeightingActive': 'Automatic weighting active: the weighting is optimized automatically based on the number of templates.',
  'admin.aiSettings.primary': 'PRIMARY',
  'admin.aiSettings.totalWeight': 'Total: {{total}}% (should be 100%)',
  'admin.aiSettings.normalize': 'Normalize',
  'admin.aiSettings.combinedSettings': 'Combined settings ({{count}} templates)',
  'admin.aiSettings.strictness': 'Strictness',
  'admin.aiSettings.realism': 'Realism',
  'admin.aiSettings.creativity': 'Creativity',
  'admin.aiSettings.detailLevel': 'Detail depth',
  'admin.aiSettings.customInstructions': 'Custom instructions',
  'admin.aiSettings.customInstructionsDesc': 'Additional instructions combined with templates',
  'admin.aiSettings.customInstructionsPlaceholder': 'e.g. "Focus on DACH market", "Always use concrete numbers", "Compare with existing competitors"...',
  'admin.aiSettings.customInstructionsHint': 'These instructions are automatically combined with the selected templates.',
  'admin.aiSettings.manualTuning': 'Manual fine-tuning',
  'admin.aiSettings.manualTuningHint': '(optional, overrides template values)',
  'admin.aiSettings.manualTuningDesc': 'Manually adjust the combined values if you want to fine-tune something.',
  'admin.aiSettings.tone': 'Tone',
  'admin.aiSettings.toneLabel': 'Tone',
  'admin.aiSettings.lengthLabel': 'Length',
  'admin.aiSettings.presetsLabel': 'Templates',
  'admin.aiSettings.mild': 'Mild',
  'admin.aiSettings.strict': 'Strict',
  'admin.aiSettings.creative': 'Creative',
  'admin.aiSettings.realistic': 'Realistic',
  'admin.aiSettings.conservative': 'Conservative',
  'admin.aiSettings.compact': 'Compact',
  'admin.aiSettings.detailed': 'Detailed',
  'admin.aiSettings.responseLength': 'Response length',
  'admin.aiSettings.lengthShort': 'Short & concise',
  'admin.aiSettings.lengthMedium': 'Medium',
  'admin.aiSettings.lengthLong': 'Detailed',
  'admin.aiSettings.focusAreas': 'Analysis focus areas',
  'admin.aiSettings.autoRating': 'Automatic rating',
  'admin.aiSettings.autoRatingDesc': 'Each analysis gets an automatic rating (Good/Medium/Poor)',
  'admin.aiSettings.showSources': 'Show sources',
  'admin.aiSettings.showSourcesDesc': 'References to data sources and market data in responses',
  'admin.aiSettings.hidePreview': 'Hide preview',
  'admin.aiSettings.showPreview': 'Show preview',
  'admin.aiSettings.aiBehavior': 'AI behavior',
  'admin.aiSettings.liveExample': 'Live example',
  'admin.aiSettings.testSettings': 'Test your settings',
  'admin.aiSettings.pickSampleQuestion': 'Pick a sample question:',
  'admin.aiSettings.userAsks': 'User asks:',
  'admin.aiSettings.generatingAnswer': 'AI generating answer...',
  'admin.aiSettings.generateSample': 'Generate sample answer',
  'admin.aiSettings.aiAnswers': 'AI assistant answers:',
  'admin.aiSettings.generateHint': 'Click "Generate sample answer" to see how the AI responds with your settings.',
  'admin.aiSettings.reset': 'Reset',
  'admin.aiSettings.saved': 'Saved!',
  'admin.aiSettings.saveSettings': 'Save settings',
  'admin.aiSettings.toneDirect': 'Direct & blunt',
  'admin.aiSettings.toneProfessional': 'Professional & factual',
  'admin.aiSettings.toneHonest': 'Honest & practical',
  'admin.aiSettings.toneMotivating': 'Motivating & positive',
  'admin.aiSettings.toneFriendly': 'Friendly & supportive',
  'admin.aiSettings.toneAcademic': 'Academic & analytical',
  'admin.aiSettings.focus.marketAnalysis': 'Market analysis',
  'admin.aiSettings.focus.competition': 'Competition',
  'admin.aiSettings.focus.monetization': 'Monetization',
  'admin.aiSettings.focus.risks': 'Risks',
  'admin.aiSettings.focus.finance': 'Finance',
  'admin.aiSettings.focus.scaling': 'Scaling',
  'admin.aiSettings.focus.innovation': 'Innovation',
  'admin.aiSettings.focus.trends': 'Trends',
  'admin.aiSettings.focus.differentiation': 'Differentiation',
  'admin.aiSettings.focus.execution': 'Execution',
  'admin.aiSettings.focus.audience': 'Target audience',
  'admin.aiSettings.focus.marketing': 'Marketing',
  'admin.aiSettings.sample.niche': 'Which profitable niche do you recommend to me?',
  'admin.aiSettings.sample.evaluate': 'Rate my idea: An app for dog owners',
  'admin.aiSettings.sample.trends': 'Which trends have potential right now?',
  'admin.aiSettings.sample.sharpen': 'How can I sharpen my niche?',
  'footer.disclaimer': 'Disclaimer',
  'legal.backToHome': 'Back to home',
  'legal.lastUpdated': 'Last updated',
  'legal.authoritativeNotice': 'A localised version is not yet available in your language. The English authoritative text is shown below.',
  'legal.translationNotice': 'This is a convenience translation. The English version is the legally binding original.',
};

export default common;
